/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";

const TypeofConnectors = ({ props }) => {
  const classes = useStyles();
  const arr = props?.map((props) => {
    return (
      <>
        <Box
          className={classes.TypeofConnectors}
          sx={{
            width: "26%",
            border: "1px solid #EBEBEB",
            borderRadius: "4px",
            justifyContent: "space-between",
            padding: "25px 25px 15px 25px",
            marginRight: "15px",
            marginTop: "15px",
          }}
        >
          <Text
            variant="h"
            component="div"
            gutterBottom
            sx={{
              display: "flex",
              color: "#474747",
              fontSize: "14px",
            }}
          >
            <Text
              variant="h"
              component="div"
              gutterBottom
              sx={{
                color: "#474747",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              Charging point
            </Text>

            <Text
              variant="h"
              component="div"
              gutterBottom
              sx={{
                color: "#474747",
                fontSize: "14px",
                fontWeight: "600",
                margin: "0 10px 0 10px",
              }}
            >
              :
            </Text>

            {props.charge_point_name}
          </Text>

          <Box
            className={classes.TypeofConnectors}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "10px 0px 20px 0px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <img
                src={props.image ? props.image : "Connectors_image.png"}
                width="72px"
                height="72px"
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Text
                variant="h"
                component="div"
                gutterBottom
                sx={{
                  color: "#474747",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {props.connectorType}
              </Text>
              <Text
                variant="h"
                component="div"
                gutterBottom
                sx={{
                  color: "#707070",
                  fontSize: "14px",
                }}
              >
                {props.power} Kw -{props.level}
              </Text>
              <Text
                variant="h"
                component="div"
                gutterBottom
                sx={{
                  color: "#707070",
                  fontSize: "14px",
                }}
              >
                &#8377; {props.price} /Kw
              </Text>

              <Text
                variant="h"
                component="div"
                gutterBottom
                sx={{
                  color: "#707070",
                  fontSize: "14px",
                }}
              >
                {props.status === 1 ? "Available" : "Not Available "}
              </Text>
            </Box>
          </Box>
        </Box>
      </>
    );
  });

  return <>{arr}</>;
};

const useStyles = makeStyles((theme) => ({
  TypeofConnectors: {
    ["@media (max-width:768px)"]: {
      width: "75%",
    },
  },
}));

export default TypeofConnectors;
